import React from 'react';
import { I18n } from 'react-redux-i18n';
import ConstCommon from '../../../../common/Const';
import CurrentState from '../../../../helpers/CurrentState';
import Const from '../Const';
import { connect } from 'react-redux';
import {
  REDUCER_NAME,
  getFilterLineOne,
  fetchAccumulation,
  getFilterLineTwo,
  getFilterLineThree,
  getFilterLineFour,
} from './../reducer';
import TabFilter from '../../../../common/tab-filter';
import InfoFilterSelect from './InfoFilterSelect';
import './index.scss';

const defaultFilter = {
  currentTabState: 1,
  currentFilterLineOne: 1,
  currentFilterLineTwo: 2,
  currentFilterLineThree: 3,
  currentFilterLineFour: 2,
};

class TabFilterTaStrategy extends React.Component {
  constructor(props) {
    super(props);
    this.state =
      CurrentState.get(ConstCommon.listComponent.Strategy, 'taStrategyState') ||
      defaultFilter;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentTabData !== this.props.currentTabData) {
      const { currentTabData, filterData } = nextProps;
      let currenFilterDefault = this.changeDefaultCurrenTabFilter(
        nextProps.currentTab,
      );
      let lineOne = currenFilterDefault[0];
      let lineTwo = currenFilterDefault[1];
      let lineThree = currenFilterDefault[2];
      let lineFour = currenFilterDefault[3];
      if (currentTabData === Const.tabs.accummulation) {
        lineOne = this.getKeyByValue(
          Const.filterTabOne.filterAccumulationPeriod,
          filterData[currentTabData].filterLineOne,
        );
        lineTwo = this.getKeyByValue(
          Const.filterTabOne.filterVolumeRateChange,
          filterData[currentTabData].filterLineTwo,
        );
        lineThree = this.getKeyByValue(
          Const.filterTabOne.filterIncreasePrice,
          filterData[currentTabData].filterLineThree,
        );
      }
      if (currentTabData === Const.tabs.breakOut) {
        lineOne = this.getKeyByValue(
          Const.filterBreakout.filterTimeRange,
          filterData[currentTabData].filterLineOne,
        );
        lineTwo = this.getKeyByValue(
          Const.filterBreakout.filterVolumeRateChange,
          filterData[currentTabData].filterLineTwo,
        );
        lineThree = this.getKeyByValue(
          Const.filterBreakout.filterCompGroup,
          filterData[currentTabData].filterLineThree,
        );
      }
      if (currentTabData === Const.tabs.breakOutMa) {
        lineOne = this.getKeyByValue(
          Const.filterBreakoutMa.breakoutMaBottom,
          filterData[currentTabData].filterLineOne,
        );
        lineTwo = this.getKeyByValue(
          Const.filterBreakoutMa.filterVolumeRateChange,
          filterData[currentTabData].filterLineTwo,
        );
        lineThree = this.getKeyByValue(
          Const.filterBreakoutMa.filterIncreasePrice,
          filterData[currentTabData].filterLineThree,
        );
      }
      if (currentTabData === Const.tabs.bestInDowntrend) {
        lineOne = this.getKeyByValue(
          Const.filterBestDownTrend.downTrend,
          filterData[currentTabData].filterLineOne,
        );
        lineTwo = this.getKeyByValue(
          Const.filterBestDownTrend.avgVolume,
          filterData[currentTabData].filterLineTwo,
        );
        lineThree = this.getKeyByValue(
          Const.filterBestDownTrend.filterCompGroup,
          filterData[currentTabData].filterLineThree,
        );
      }
      if (currentTabData === Const.tabs.marketAnomaly) {
        if (
          filterData[currentTabData].checkboxMarketNormally ===
          Const.filterMarketAbnormally.optionTime.Daily
        ) {
          lineOne = this.getKeyByValue(
            Const.filterMarketAbnormally.filterWeekday,
            filterData[currentTabData].filterLineOne,
          );
        }
        if (
          filterData[currentTabData].checkboxMarketNormally ===
          Const.filterMarketAbnormally.optionTime.Monthly
        ) {
          lineOne = this.getKeyByValue(
            Const.filterMarketAbnormally.filterMonthly,
            filterData[currentTabData].filterLineOne,
          );
        }
        if (
          filterData[currentTabData].checkboxMarketNormally ===
          Const.filterMarketAbnormally.optionTime.Quarterly
        ) {
          lineOne = this.getKeyByValue(
            Const.filterMarketAbnormally.filterQuarterly,
            filterData[currentTabData].filterLineOne,
          );
        }

        lineTwo = this.getKeyByValue(
          Const.filterMarketAbnormally.filterTimeRange,
          filterData[currentTabData].filterLineTwo,
        );
        lineThree = this.getKeyByValue(
          Const.filterMarketAbnormally.avgVolume,
          filterData[currentTabData].filterLineThree,
        );
      }
      if (currenFilterDefault.length > 3) {
        lineFour = this.getKeyByValue(
          Const.filterMarketAbnormally.filterCompGroup,
          filterData[currentTabData].filterTabLineFour,
        );
        this.setState({
          currentFilterLineFour: lineFour,
        });
      }
      this.setState({
        ...this.state,
        currentFilterLineOne: lineOne,
        currentFilterLineTwo: lineTwo,
        currentFilterLineThree: lineThree,
        currentTabState: nextProps.currentTab,
      });
    }
  }

  componentWillUpdate(prevProps) {
    const { currentTabData, filterData } = this.props;
    if (currentTabData === Const.tabs.marketAnomaly) {
      if (
        prevProps.filterData[currentTabData].checkboxMarketNormally !==
        filterData[currentTabData].checkboxMarketNormally
      ) {
        if (
          filterData[currentTabData].checkboxMarketNormally ===
            Const.filterMarketAbnormally.optionTime.Daily ||
          filterData[currentTabData].checkboxMarketNormally ===
            Const.filterMarketAbnormally.optionTime.Monthly ||
          filterData[currentTabData].checkboxMarketNormally ===
            Const.filterMarketAbnormally.optionTime.Quarterly
        ) {
          this.setState({
            ...this.state,
            currentFilterLineOne: 1,
          });
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      CurrentState.add(
        ConstCommon.listComponent.Strategy,
        'taStrategyState',
        this.state,
      );
    }
  }

  changeDefaultCurrenTabFilter = currentTab => {
    const map = {
      [Const.tabs.accummulation]: [1, 2, 3],
      [Const.tabs.breakOut]: [1, 2, 2],
      [Const.tabs.breakOutMa]: [1, 2, 3],
      [Const.tabs.bestInDowntrend]: [1, 2, 2],
      [Const.tabs.marketAnomaly]: [1, 3, 2],
    };
    return map[currentTab];
  };

  changeFilterLineOne = currentFilterLineOne => {
    const { currentTab, getFilterLineOne } = this.props;
    if (currentTab === Const.tabs.accummulation) {
      getFilterLineOne(
        Const.filterTabOne.filterAccumulationPeriod[currentFilterLineOne],
      );
    }
    if (currentTab === Const.tabs.breakOut) {
      getFilterLineOne(
        Const.filterBreakout.filterTimeRange[currentFilterLineOne],
      );
    }
    if (currentTab === Const.tabs.breakOutMa) {
      getFilterLineOne(
        Const.filterBreakoutMa.breakoutMaBottom[currentFilterLineOne],
      );
    }
    if (currentTab === Const.tabs.bestInDowntrend) {
      getFilterLineOne(
        Const.filterBestDownTrend.downTrend[currentFilterLineOne],
      );
    }
    if (currentTab === Const.tabs.marketAnomaly) {
      const { filterData } = this.props;
      if (
        filterData[currentTab].checkboxMarketNormally ===
        Const.filterMarketAbnormally.optionTime.Daily
      ) {
        getFilterLineOne(
          Const.filterMarketAbnormally.filterWeekday[currentFilterLineOne],
        );
      }
      if (
        filterData[currentTab].checkboxMarketNormally ===
        Const.filterMarketAbnormally.optionTime.Monthly
      ) {
        getFilterLineOne(
          Const.filterMarketAbnormally.filterMonthly[currentFilterLineOne],
        );
      }
      if (
        filterData[currentTab].checkboxMarketNormally ===
        Const.filterMarketAbnormally.optionTime.Quarterly
      ) {
        getFilterLineOne(
          Const.filterMarketAbnormally.filterQuarterly[currentFilterLineOne],
        );
      }
    }
    this.setState({
      ...this.state,
      currentFilterLineOne,
    });
  };

  changeFilterLineTwo = currentFilterLineTwo => {
    const { currentTab, getFilterLineTwo } = this.props;
    if (currentTab === Const.tabs.accummulation) {
      getFilterLineTwo(
        Const.filterTabOne.filterVolumeRateChange[currentFilterLineTwo],
      );
    }
    if (currentTab === Const.tabs.breakOut) {
      getFilterLineTwo(
        Const.filterBreakout.filterVolumeRateChange[currentFilterLineTwo],
      );
    }
    if (currentTab === Const.tabs.breakOutMa) {
      getFilterLineTwo(
        Const.filterBreakoutMa.filterVolumeRateChange[currentFilterLineTwo],
      );
    }
    if (currentTab === Const.tabs.bestInDowntrend) {
      getFilterLineTwo(
        Const.filterBestDownTrend.avgVolume[currentFilterLineTwo],
      );
    }
    if (currentTab === Const.tabs.marketAnomaly) {
      getFilterLineTwo(
        Const.filterMarketAbnormally.filterTimeRange[currentFilterLineTwo],
      );
    }
    this.setState({
      ...this.state,
      currentFilterLineTwo,
    });
  };

  changeFilterLineThree = currentFilterLineThree => {
    const { currentTab, getFilterLineThree } = this.props;
    if (currentTab === Const.tabs.accummulation) {
      getFilterLineThree(
        Const.filterTabOne.filterIncreasePrice[currentFilterLineThree],
      );
    }
    if (currentTab === Const.tabs.breakOut) {
      getFilterLineThree(
        Const.filterBreakout.filterCompGroup[currentFilterLineThree],
      );
    }
    if (currentTab === Const.tabs.breakOutMa) {
      getFilterLineThree(
        Const.filterBreakoutMa.filterIncreasePrice[currentFilterLineThree],
      );
    }
    if (currentTab === Const.tabs.bestInDowntrend) {
      getFilterLineThree(
        Const.filterBestDownTrend.filterCompGroup[currentFilterLineThree],
      );
    }
    if (currentTab === Const.tabs.marketAnomaly) {
      getFilterLineThree(
        Const.filterMarketAbnormally.avgVolume[currentFilterLineThree],
      );
    }
    this.setState({
      ...this.state,
      currentFilterLineThree,
    });
  };

  changeFilterLineFour = currentFilterLineFour => {
    const { currentTab, getFilterLineFour } = this.props;
    if (currentTab === Const.tabs.marketAnomaly) {
      getFilterLineFour(
        Const.filterMarketAbnormally.filterCompGroup[currentFilterLineFour],
      );
    }
    this.setState({
      ...this.state,
      currentFilterLineFour,
    });
  };

  getInfoFilter = () => {
    const { currentTab, filterData, breakOutType } = this.props;
    const {
      currentFilterLineOne,
      currentFilterLineTwo,
      currentFilterLineThree,
      currentFilterLineFour,
    } = this.state;

    let lineOne = 'filterHighestReturnCondition';
    if (currentTab === Const.tabs.marketAnomaly) {
      if (
        filterData[currentTab].checkboxMarketNormally ===
        Const.filterMarketAbnormally.optionTime.Daily
      ) {
        lineOne = 'filterHighestReturnCondition';
      }
      if (
        filterData[currentTab].checkboxMarketNormally ===
        Const.filterMarketAbnormally.optionTime.Monthly
      ) {
        lineOne = 'filterHighestReturnConditionMonthly';
      }
      if (
        filterData[currentTab].checkboxMarketNormally ===
        Const.filterMarketAbnormally.optionTime.Quarterly
      ) {
        lineOne = 'filterHighestReturnConditionQuaterly';
      }
    }
    const map = {
      [Const.tabs.accummulation]: [
        `${
          I18n.t('taStrategy.filterAccumulationPeriodCondition')[
            currentFilterLineOne
          ]
        }`,
        `${
          I18n.t('taStrategy.filterVolumnRateOfChangeTabOneCondition')[
            currentFilterLineTwo
          ]
        }`,
        `${
          I18n.t('taStrategy.filterIncreaseInPriceTabOneCondition')[
            currentFilterLineThree
          ]
        }`,
      ],

      [Const.tabs.breakOut]: [
        `${
          I18n.t('taStrategy.filterStockGroupTabTwoCondition')[
            currentFilterLineThree
          ]
        }`,
        breakOutType === Const.filterBreakout.breakOutType.TOP
          ? `${
              I18n.t('taStrategy.filterBreakoutTopWithinCondition')[
                currentFilterLineOne
              ]
            }`
          : `${
              I18n.t('taStrategy.filterBreakoutTopWithinConditionBottom')[
                currentFilterLineOne
              ]
            }`,
        `${
          I18n.t('taStrategy.filterVolumnRateOfChangeTabTwoCondition')[
            currentFilterLineTwo
          ]
        }`,
      ],

      [Const.tabs.breakOutMa]: [
        filterData[currentTab].breakOutType ===
        Const.filterBreakoutMa.breakOutType.CROSS_UP
          ? `${
              I18n.t('taStrategy.filterBreakoutMaBottomCondition')[
                currentFilterLineOne
              ]
            }`
          : `${
              I18n.t('taStrategy.filterBreakoutMaBottomConditionDown')[
                currentFilterLineOne
              ]
            }`,
        `${
          I18n.t('taStrategy.filterVolumnRateOfChangeTabThreeCondition')[
            currentFilterLineTwo
          ]
        }`,
        filterData[currentTab].breakOutType ===
        Const.filterBreakoutMa.breakOutType.CROSS_UP
          ? `${
              I18n.t('taStrategy.filterIncreaseInPriceTabThreeCondition')[
                currentFilterLineThree
              ]
            }`
          : `${
              I18n.t('taStrategy.filterIncreaseInPriceTabThreeConditionDown')[
                currentFilterLineThree
              ]
            }`,
      ],

      [Const.tabs.bestInDowntrend]: [
        `${
          I18n.t('taStrategy.filterStockGroupTabFourCondition')[
            currentFilterLineThree
          ]
        }`,
        `${
          I18n.t('taStrategy.filterAverageVol1mTabFourCondition')[
            currentFilterLineTwo
          ]
        }`,
        I18n.t('taStrategy.theHighestEps'),
        `${
          I18n.t('taStrategy.filterVNIndexDowntrendCondition')[
            currentFilterLineOne
          ]
        }`,
      ],

      [Const.tabs.marketAnomaly]: [
        `${
          I18n.t('taStrategy.filterStockGroupTabFiveCondition')[
            currentFilterLineFour
          ]
        }`,
        `${I18n.t('taStrategy.' + lineOne)[currentFilterLineOne]}`,
        `${
          I18n.t('taStrategy.filterAverageVol1mTabFiveCondition')[
            currentFilterLineThree
          ]
        }`,
        `${
          I18n.t('taStrategy.filterCaculationPeriodCondition')[
            currentFilterLineTwo
          ]
        }`,
      ],
    };
    return map[currentTab];
  };

  getInfoFilterDefault = () => {
    const { currentTab } = this.props;
    const map = {
      [Const.tabs.accummulation]: [
        I18n.t(`taStrategy.defaultAccummulationfilter.stockAccumulate`),
        I18n.t(`taStrategy.defaultAccummulationfilter.with`),
        I18n.t(`taStrategy.defaultAccummulationfilter.and`),
      ],

      [Const.tabs.breakOut]: [
        I18n.t(`taStrategy.defaultBreakOutfilter.stockIn`),
        I18n.t(`taStrategy.defaultBreakOutfilter.that`),
        I18n.t(`taStrategy.defaultBreakOutfilter.with`),
      ],

      [Const.tabs.breakOutMa]: [
        I18n.t(`taStrategy.defaultBreakOutMafilter.stockThat`),
        I18n.t(`taStrategy.defaultBreakOutMafilter.with`),
        I18n.t(`taStrategy.defaultBreakOutMafilter.and`),
      ],

      [Const.tabs.bestInDowntrend]: [
        I18n.t(`taStrategy.defaultBestInDowntrendfilter.stockIn`),
        I18n.t(`taStrategy.defaultBestInDowntrendfilter.with`),
        I18n.t(`taStrategy.defaultBestInDowntrendfilter.and`),
        I18n.t(`taStrategy.defaultBestInDowntrendfilter.within`),
      ],

      [Const.tabs.marketAnomaly]: [
        I18n.t(`taStrategy.defaultMarketAnomalyfilter.stockIn`),
        I18n.t(`taStrategy.defaultMarketAnomalyfilter.with`),
        I18n.t(`taStrategy.defaultMarketAnomalyfilter.and`),
        I18n.t(`taStrategy.defaultMarketAnomalyfilter.over`),
      ],
    };
    return map[currentTab];
  };

  getKeyByValue = (object, value) => {
    return parseInt(Object.keys(object).find(key => object[key] === value));
  };

  render() {
    const { currentTab, titleFilter, filterTypeTab, filterData } = this.props;

    const infoFilterTabDefault = this.getInfoFilterDefault();
    const infoFilterTab = this.getInfoFilter();

    let filterTabLineFour = '';
    if (currentTab === Const.tabs.marketAnomaly) {
      filterTabLineFour = (
        <div className="list-filter-ta-strategy">
          <span
            className="left-label-ta-strategy"
            style={{ fontWeight: 'bold' }}
          >
            {I18n.t(titleFilter[3])}
          </span>
          <TabFilter
            currentTab={this.state.currentFilterLineFour}
            listTab={filterTypeTab[3]}
            changeTab={this.changeFilterLineFour}
          />
        </div>
      );
    }

    if (currentTab === 3) {
      if (
        filterData[3].breakOutType ===
        Const.filterBreakoutMa.breakOutType.CROSS_DOWN
      )
        filterTypeTab[2] = 'taStrategy.filterIncreaseInPriceTabThreeDown';
    }

    return (
      <>
        <div
          className={`list-filter-ta-strategy ${
            filterData[5].checkboxMarketNormally ===
              Const.filterMarketAbnormally.optionTime.Monthly &&
            currentTab === 5
              ? 'first-filter-ta'
              : ''
          } ${
            filterData[5].checkboxMarketNormally ===
              Const.filterMarketAbnormally.optionTime.Daily && currentTab === 5
              ? 'first-filter-ta-dai'
              : ''
          }`}
        >
          <span
            className="left-label-ta-strategy"
            style={{ fontWeight: 'bold' }}
          >
            {I18n.t(titleFilter[0])}
          </span>
          <TabFilter
            currentTab={this.state.currentFilterLineOne}
            listTab={filterTypeTab[0]}
            changeTab={this.changeFilterLineOne}
          />
        </div>

        <div className="list-filter-ta-strategy">
          <span
            className="left-label-ta-strategy"
            style={{ fontWeight: 'bold' }}
          >
            {I18n.t(titleFilter[1])}
          </span>
          <TabFilter
            currentTab={this.state.currentFilterLineTwo}
            listTab={filterTypeTab[1]}
            changeTab={this.changeFilterLineTwo}
          />
        </div>

        <div className="list-filter-ta-strategy">
          <span
            className="left-label-ta-strategy"
            style={{ fontWeight: 'bold' }}
          >
            {I18n.t(titleFilter[2])}
          </span>
          <TabFilter
            currentTab={this.state.currentFilterLineThree}
            listTab={filterTypeTab[2]}
            changeTab={this.changeFilterLineThree}
          />
        </div>

        {filterTabLineFour}

        <div className="mt-5">
          <InfoFilterSelect
            infoFilterTab={infoFilterTab}
            infoFilterTabDefault={infoFilterTabDefault}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  filterData: state[REDUCER_NAME].filterData,
  currentTabData: state[REDUCER_NAME].currentTabData,
  breakOutType:
    state[REDUCER_NAME].filterData[state[REDUCER_NAME].currentTabData]
      .breakOutType,
});

const mapDispatchToProps = {
  getFilterLineOne,
  fetchAccumulation,
  getFilterLineTwo,
  getFilterLineThree,
  getFilterLineFour,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TabFilterTaStrategy);
